import React from 'react';
import { IntlProvider } from 'react-intl';
import { TranslationProvider } from '@crunchyroll/cx-web-components';
import PropTypes from 'prop-types';

import connect from 'app/libs/connect';
import { dashedUserLocale } from 'app/features/user/selectors';
import { translations } from 'app/features/localization/selectors';

const UI = ({ children, locale, messages }) => (
  <IntlProvider locale={locale} key={locale} messages={messages}>
    <TranslationProvider value={messages}>{children}</TranslationProvider>
  </IntlProvider>
);

UI.propTypes = {
  locale: PropTypes.string.isRequired,
  messages: PropTypes.shape({}).isRequired,
  children: PropTypes.node.isRequired,
};

const state = {
  locale: dashedUserLocale,
  messages: translations,
};

const ConnectedIntlProvider = connect(state)(UI);

export default ConnectedIntlProvider;
